import { render, staticRenderFns } from "./SearchStatsHeaderSkeleton.vue?vue&type=template&id=1c6d997e&"
import script from "./SearchStatsHeaderSkeleton.vue?vue&type=script&lang=ts&"
export * from "./SearchStatsHeaderSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports